import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import {AuthenticationService} from "../../../core";
import {NzDrawerRef} from "ng-zorro-antd/drawer";
import {CompanyService} from "../../../core/services/company.service";
import {Company} from "../../models/company";
import {User} from "../../models/user";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {ConfirmModalComponent} from "../confirm-modal/confirm-modal.component";
import {take} from "rxjs";
import {NzModalService} from "ng-zorro-antd/modal";
import {OidcSecurityService} from "angular-auth-oidc-client";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-user-drawer',
  templateUrl: './user-drawer.component.html',
  styleUrl: './user-drawer.component.less'
})
export class UserDrawerComponent implements AfterViewInit {

  step: number = 1;
  userInitials: string = 'U';
  company: Company | undefined;
  user: User | undefined;

  confirmLogoutModalRef: any;
  selectedCompanyId: number = 0;
  constructor(
    private authService: AuthenticationService,
    private companyService: CompanyService,
    private drawerRef: NzDrawerRef,
    private modalService: NzModalService,
    private oidcSecurityService: OidcSecurityService,
  ) {
    authService.loggedUser
      .pipe(takeUntilDestroyed())
      .subscribe((user) => this.user = user);

    companyService.selectedCompany
      .pipe(takeUntilDestroyed())
      .subscribe((company) => {
        this.company = company;
        this.selectedCompanyId = this.company?.id || 0;
      })
  }

  ngAfterViewInit(): void {
    // Forzar la carga inicial de iconos
    this.forceIconReload();
  }

  selectCompany() {
    this.companyService.selectedCompany = this.user ? this.user.companies.find(c => c.id === this.selectedCompanyId) : undefined;
    this.step = 1;
  }

  openConfirmLogout(): void {
    this.confirmLogoutModalRef = this.modalService.create({
      nzContent: ConfirmModalComponent,
      nzFooter: null,
      nzCentered: true,
      nzMask: true,
      nzMaskStyle: {
        'backdrop-filter': 'blur(4px)',
        '-webkit-backdrop-filter': 'blur(4px)' // Soporte para navegadores WebKit (Safari, Chrome antiguos)
      }
    })

    this.confirmLogoutModalRef.getContentComponent().topIcon = {
      name: 'triangle-alert',
      color: '#088050',
      backgroundColor: '#C8F0E0',
    }
    this.confirmLogoutModalRef.getContentComponent().title = '¿Cerrar sesión ahora?';
    this.confirmLogoutModalRef.getContentComponent().content = 'Si cierras tu sesión, podrías perder cambios no guardados. Podrás volver a ingresar cuando lo desees.';
    this.confirmLogoutModalRef.getContentComponent().confirmText = 'Cerrar sesión';
    this.confirmLogoutModalRef.getContentComponent().type = 'confirm'
    // Manejo del confirm
    this.confirmLogoutModalRef.getContentComponent().confirm.pipe(take(1)).subscribe(() => {
      this.confirmLogoutModalRef.getContentComponent().loading = true;
      this.oidcSecurityService
        .logoff()
        .subscribe(() => {
          this.companyService.selectedCompany = undefined;
          this.confirmLogoutModalRef.getContentComponent().loading = false;
          this.confirmLogoutModalRef.close();
        });
    });
  }

  close() {
    this.drawerRef.close();
  }

  /**
   * Fuerza la recarga de todos los iconos en el componente
   */
  private forceIconReload(): void {
    // Usar setTimeout para asegurar que el DOM esté actualizado
    setTimeout(() => {
      const iconElements = document.querySelectorAll('app-icon');
      iconElements.forEach((iconElement: any) => {
        if (iconElement.reloadIcon) {
          iconElement.reloadIcon();
        }
      });
    }, 0);
  }

  /**
   * Cambia el step y fuerza la recarga de iconos
   */
  changeStep(newStep: number): void {
    this.step = newStep;
    // Forzar recarga de iconos después del cambio de step
    setTimeout(() => {
      this.forceIconReload();
    }, 100);
  }

  changePass() {
    window.location.href = environment.production ? 'https://sso.mojito360.com/Account/ForgotPassword' : 'https://sso.pre.mojito360.com/Account/ForgotPassword';
  }

}
